import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { hasValidSession } from "@/lib/auth";

/** Route guard - checks Cognito session, redirects to /login if absent. */
export function RequireAuth(props: { children: React.ReactNode }): JSX.Element {
  const [checked, setChecked] = useState(false);
  const [authed, setAuthed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    void hasValidSession().then((v) => {
      setAuthed(v);
      setChecked(true);
    });
  }, []);

  if (!checked) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        Checking session…
      </div>
    );
  }

  if (!authed) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{props.children}</>;
}
